import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {
  selectOnlineState,
  selectRecoverableErrors
} from '@app/store/Selectors/application-health/application-health.selectors';
import {Store} from '@ngrx/store';
import {IError} from '@app/store/Models/application-health/models';
import {untilDestroyed} from '@core';
import { environment } from '@env/environment';

/**
 * Component for the notification bar
 * This bar shows ongoing errors, mostly with API calls and such
 */
@Component({
    selector: 'app-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
    standalone: false
})
export class NotificationBarComponent implements OnInit, OnDestroy {

  public isOnline: Observable<boolean> = this.store.select(selectOnlineState)
    .pipe(untilDestroyed(this));
  public errors: IError[];
  showErrorBar = environment.showErrorNotificationBar;

  constructor(private store: Store) { }

  ngOnInit(): void {
    // Observe ongoing errors
    this.store.select(selectRecoverableErrors)
      .pipe(untilDestroyed(this))
      .subscribe(recoverableErrors => {
        this.errors = recoverableErrors;
      })
  }

  ngOnDestroy(): void {
  }

}
